import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Faixa de título com texto de localização (“ONDE ESTOU”) e botões de ação no canto
 * direito.
 *
 * **Quando usar:** em praticamente toda tela de lista ou formulário do padrão: o
 * desenvolvedor controla se o usuário pode abrir filtros (`mostrarBotaoFiltrar` +
 * evento `alternarFiltro`) e se há retorno explícito (`mostrarBotaoVoltar` + `voltar`).
 *
 * **Integração:** projete botões extras ao lado dos padrões usando o mesmo padrão
 * visual da página (ex.: Incluir, Excel). O componente não conhece rota nem serviço.
 *
 * @see FilterBoxComponent Painel que costuma ser aberto/fechado em conjunto com o botão Filtrar
 */
@Component({
  selector: 'app-title-box',
  templateUrl: './title-box.component.html',
  styleUrls: ['./title-box.component.scss'],
})
export class TitleBoxComponent {
  /** Texto exibido após o rótulo “ONDE ESTOU”. */
  @Input() local = '';

  /** Se `false`, o botão “Filtrar resultados” não é renderizado. */
  @Input() mostrarBotaoFiltrar = true;

  /** Se `true`, exibe o botão “Voltar” antes das demais ações (ex.: sair do cadastro). */
  @Input() mostrarBotaoVoltar = false;

  /** Emite ao clicar em “Filtrar resultados”; a tela pai alterna o estado do `FilterBox`. */
  @Output() alternarFiltro = new EventEmitter<void>();

  /** Emite ao clicar em “Voltar”; normalmente `Router.navigate` para a lista. */
  @Output() voltar = new EventEmitter<void>();

  onAlternarFiltro(): void {
    this.alternarFiltro.emit();
  }

  onVoltar(): void {
    this.voltar.emit();
  }
}
